import { useAutocompleteSource } from '@eas/common-web';
import { DictEmploymentPositionAutocomplete } from '@models';
import { EvidenceApiUrl } from '@enums';

export function useEmploymentPositions() {
  return useAutocompleteSource<DictEmploymentPositionAutocomplete>({
    url: `${EvidenceApiUrl.DICT_EMPLOYMENT_POSITION}/autocomplete`,
  });
}
